

/**
 *  Parses a url argument and returns an object with all the parameters
 *  @param String url
 *  @return object
**/

const getUrlParams = function (url) {

        // get query string from url (optional) or window
        var queryString = url ? url.split('?')[1] : "";

        // we'll store the parameters here
        var obj = {};

        // if query string exists
        if (queryString) {

            // stuff after # is not part of query string, so get rid of it
            queryString = queryString.split('#')[0];

            // split our query string into its component parts
            var arr = queryString.split('&');

            for (var i = 0; i < arr.length; i++) {
                // separate the keys and the values
                var a = arr[i].split('=');

                // set parameter name and value (use 'true' if empty)
                var paramName = a[0];
                var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                // (optional) keep case consistent
                paramName = paramName.toLowerCase();
                if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                if (paramName.match(/\[(\d+)?\]$/)) {

                    // create key if it doesn't exist
                    var key = paramName.replace(/\[(\d+)?\]/, '');
                    if (!obj[key]) obj[key] = [];

                    // if it's an indexed array e.g. colors[2]
                    if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        var index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                    } else {
                        // otherwise add the value to the end of the array
                        obj[key].push(paramValue);
                    }
                } else {
                    // we're dealing with a string
                    if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }
                }
            }
        }

        return obj;
}

/**
 *  Parses an object with params and concats those values to create a url with params
 *  @param String url
 *  @param Object params
 *  @return String
 * **/

const glueParamsToUrl = function (url, params){
    if(typeof params != 'object' || params == null  ||!Object.keys(params).length){
        return url;
    }

    var paramsString = "";
    var count = 0;

    for (var param in params ) {

        if (!params.hasOwnProperty(param)) {
            continue;
        }

        paramsString += param + "=" + params[param];
        count++;

        //skip addition of & to the end of the first param
        if (count && count !== Object.keys(params).length) {
            paramsString += "&";
        }

    }

    if(url.indexOf('?')  > -1){
        return url + '&' + paramsString;
    }
    return url + '?' + paramsString;

}

/**
 *  Parses the DOM starting from the element and searching the parents for the given selector
 *  @param Node el
 *  @param String selector
 *  @return Node || null
 * **/

const closestSelector  = function (el, lookUpSelector) {
    if (!el || el.tagName == "BODY") {
        return null;
    }

    var originalEl = el ;

    if (lookUpSelector.indexOf("#") === 0) {
        lookUpSelector = lookUpSelector.replace("#","");
        while (!el.getAttribute("id") ||  ( el.getAttribute("id") && el.getAttribute("id") !== lookUpSelector) ){

            el = el.parentNode;

            if (!el || el.tagName == "BODY") {
                el = null;
                break;
            }
        }

    } else if (lookUpSelector.indexOf("[") === 0 && lookUpSelector.indexOf("]") > -1 && lookUpSelector.lastIndexOf("]") === lookUpSelector.length -1) {

        lookUpSelector = lookUpSelector.replace("[","").replace("]","");
        var attributeValueSelector = "";
        var attributeNameSelector = "";

        if (lookUpSelector.indexOf("=") > -1) {
            attributeNameSelector = lookUpSelector.split("=")[0];
            attributeValueSelector = lookUpSelector.split("=")[1];
        } else {
            attributeNameSelector = lookUpSelector;
        }

        if (attributeValueSelector) {
            while ( !el.getAttribute  || !el.getAttribute(attributeNameSelector) || el.getAttribute(attributeNameSelector) !== attributeValueSelector ) {

                el = el.parentNode;

                if (!el || el.tagName == "BODY") {
                    el = null;
                    break;
                }
            }
        } else {
            while ( !el.getAttribute  || !el.getAttribute(attributeNameSelector) ) {

                el = el.parentNode;

                if (!el || el.tagName == "BODY") {
                    el = null;
                    break;
                }
            }
        }

    } else {
        lookUpSelector = lookUpSelector.replace(".","");
        while ( !el.classList  || !el.classList.contains || !el.classList.contains(lookUpSelector) ) {

            el = el.parentNode;

            if (!el || el.tagName == "BODY") {
                el = null;
                break;
            }
        }
    }

    return el;
}

const nextSiblingUntil = function (el,lookUpSelector) {

    if (!el || el.tagName == "BODY") {
        return null;
    }

    var originalEl = el ;

    if (lookUpSelector.indexOf("#") === 0) {
        lookUpSelector = lookUpSelector.replace("#","");
        while (!el.getAttribute("id") ||  ( el.getAttribute("id") && el.getAttribute("id") !== lookUpSelector) ){

            el = el.nextElementSibling;

            if (!el || el.tagName == "BODY") {
                el = null;
                break;
            }
        }

    } else if (lookUpSelector.indexOf("[") === 0 && lookUpSelector.indexOf("]") > -1 && lookUpSelector.lastIndexOf("]") === lookUpSelector.length -1) {

        lookUpSelector = lookUpSelector.replace("[","").replace("]","");
        var attributeValueSelector = "";
        var attributeNameSelector = "";

        if (lookUpSelector.indexOf("=") > -1) {
            attributeNameSelector = lookUpSelector.split("=")[0];
            attributeValueSelector = lookUpSelector.split("=")[1];
        } else {
            attributeNameSelector = lookUpSelector;
        }

        if (attributeValueSelector) {
            while ( !el.getAttribute  || !el.getAttribute(attributeNameSelector) || el.getAttribute(attributeNameSelector) !== attributeValueSelector ) {

                el = el.nextElementSibling;

                if (!el || el.tagName == "BODY") {
                    el = null;
                    break;
                }
            }
        } else {
            while ( el !== null || !el.getAttribute  || !el.getAttribute(attributeNameSelector) ) {
                el = el.nextElementSibling;

                if (!el || el.getAttribute(attributeNameSelector)) {

                    break;
                }
            }
        }

    } else {
        lookUpSelector = lookUpSelector.replace(".","");
        while ( !el.classList  || !el.classList.contains || !el.classList.contains(lookUpSelector) ) {

            el = el.nextElementSibling;

            if (!el || el.tagName == "BODY") {
                el = null;
                break;
            }
        }
    }

    return el;
}


const previousSiblingUntil = function (el,lookUpSelector) {

    if (!el || el.tagName == "BODY") {
        return null;
    }

    var originalEl = el ;

    if (lookUpSelector.indexOf("#") === 0) {
        lookUpSelector = lookUpSelector.replace("#","");
        while (!el.getAttribute("id") ||  ( el.getAttribute("id") && el.getAttribute("id") !== lookUpSelector) ){

            el = el.previousElementSibling;

            if (!el || el.tagName == "BODY") {
                el = null;
                break;
            }
        }

    } else if (lookUpSelector.indexOf("[") === 0 && lookUpSelector.indexOf("]") > -1 && lookUpSelector.lastIndexOf("]") === lookUpSelector.length -1) {

        lookUpSelector = lookUpSelector.replace("[","").replace("]","");
        var attributeValueSelector = "";
        var attributeNameSelector = "";

        if (lookUpSelector.indexOf("=") > -1) {
            attributeNameSelector = lookUpSelector.split("=")[0];
            attributeValueSelector = lookUpSelector.split("=")[1];
        } else {
            attributeNameSelector = lookUpSelector;
        }

        if (attributeValueSelector) {
            while ( !el.getAttribute  || !el.getAttribute(attributeNameSelector) || el.getAttribute(attributeNameSelector) !== attributeValueSelector ) {

                el = el.previousElementSibling;

                if (!el || el.tagName == "BODY") {
                    el = null;
                    break;
                }
            }
        } else {
            while ( el !== null || !el.getAttribute  || !el.getAttribute(attributeNameSelector) ) {
                el = el.previousElementSibling;

                if (!el || el.getAttribute(attributeNameSelector)) {

                    break;
                }
            }
        }

    } else {
        lookUpSelector = lookUpSelector.replace(".","");
        while ( !el.classList  || !el.classList.contains || !el.classList.contains(lookUpSelector) ) {

            el = el.previousElementSibling;

            if (!el || el.tagName == "BODY") {
                el = null;
                break;
            }
        }
    }

    return el;
}

/**
 *  Removes class args from given node arg OR parses the node arg to find the given class args and removes them
 *  @param Node wrapper
 *  @param Array || String classes
 *  @param String how
 * **/

const searchAndRemoveClasses = function (wrapper,classes,how,debug) {

    if (!classes) {
        return;
    }

    if (!wrapper) {
        wrapper = document;
    }

    //typecast to array to be able to parse classes passed as a string
    if (!Array.isArray(classes)) {
        classes = [classes];
    }

    classes.map( (name,classIndex) => {

        let classNames = name;
        if (debug) {
            console.log(classNames);
        }
        //check the className to see if its passed as a single class or multiple class names divided by a space
        if (name.indexOf(" ") !== -1) {
            classNames = name.split(" ");
        } else if (!Array.isArray(classNames)) {
            classNames = [name];
        }

        for (let index in classNames) {

            if (!classNames.hasOwnProperty(index)) {
                continue;
            }

            let className = classNames[index];
            className = className.trim();

            if (wrapper.classList && className) {
                wrapper.classList.remove(className);
            }

            if (how == "deep") {

                var foundNodes = wrapper.querySelectorAll("." + className);

                for (var k = 0 ; k < foundNodes.length ; k++) {
                    var foundNode = foundNodes[k];

                    if (foundNode.classList && className) {
                        foundNode.classList.remove(className);
                    }
                }
            }
        }


    })
}


/**
 *  Transform a string with an rgb color into a string of the corresponding hex color
 *  @param String rgb color
 *  @returns String hex
 * **/
const rgbToHex = function (rgb) {

    var rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
    var rgbaRegex = /^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+\.?\d*)\s*\)$/;
    var result, resultRgba, r, g, b, hex = "";

    var componentFromStr = function (numStr, percent) {
        var num = Math.max(0, parseInt(numStr, 10));
        return percent ?
            Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
    }

    if ( (result = rgbRegex.exec(rgb)) ) {
        r = componentFromStr(result[1], result[2]);
        g = componentFromStr(result[3], result[4]);
        b = componentFromStr(result[5], result[6]);

        hex = "#" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    if ( !hex.length && (resultRgba = rgbaRegex.exec(rgb)) ) {
        if(resultRgba[4] < 1){
            hex = rgb;
        }
    }
    return hex;
}

const sluggify = function (text) {
  return text.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word chars
                .replace(/--+/g, '-') // Replace multiple - with single -
                .replace(/^[-]+|[-]+$/g,'');
}

export { rgbToHex, searchAndRemoveClasses, getUrlParams, glueParamsToUrl, closestSelector, nextSiblingUntil, previousSiblingUntil, sluggify };
